import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { MenuIcon } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';

type PropsMobileMenu = {};

const MobileMenu: React.FC<PropsMobileMenu> = () => {
  const [currentRoute, setCurrentRoute] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentRoute(location.pathname);
  }, [location]);

  const handleNavigate = (route: string) => {
    navigate(route);
  };

  return (
    <Sheet key='left'>
      <SheetTrigger className='fixed top-5 left-4 p-2  rounded-full bg-[#FBFBFB]'>
        <MenuIcon />
      </SheetTrigger>
      <SheetContent side='left' className='bg-white h-[100vh]'>
        <SheetHeader>
          <SheetTitle>
            <div className=' ml-3  -mt-8 h-20'>
              <img src='/assets/icons/Hillal.svg' alt='logo' />
            </div>
          </SheetTitle>
          <SheetDescription className='flex flex-col h-[75vh] justify-between '>
            <Navigation />
          </SheetDescription>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;
